import { getJson, postJson, withValidate, withDone } from '@rad/utility/http';
export const getMeasureRequests = () => getJson('/api/measure-requests');
export const completeMeasureRequest = (id) => withDone(postJson(`/api/measure-requests/${id}/complete`))();
export const denyMeasureRequest = (x) => withDone(withValidate(postJson(`/api/measure-requests/${x.id}/deny`, x)))();
export const createMeasureRequest = (x) => withDone(withValidate(postJson('/api/measure-requests', x)))();
export const updateMeasureRequest = (x) => withDone(withValidate(postJson(`/api/measures/${x.id}`, x)))();
